export default __webpack_public_path__ + "static/hailmary-5fce53cc51eeab35babdd859509bd513.jpg";